import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { getLanguageFromLocale } from '~/utils/locale-mapper/locale-mapper';

export interface Props {
  locale?: string;
}

const LangHelmet = ({ locale }: Props) => {
  const htmlAttributes = useMemo(() => ({ lang: getLanguageFromLocale(locale) }), [locale]);
  return <Helmet htmlAttributes={htmlAttributes} />;
};

export default LangHelmet;
